module.exports = __webpack_public_path__ + "img/ete-transparency.82c2cd51.svg";